import script from "./newsletter-article-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./newsletter-article-modal.vue?vue&type=script&setup=true&lang=ts"

import "./newsletter-article-modal.vue?vue&type=style&index=0&id=0d60c3c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d60c3c4"]])

export default __exports__